<template>
  <div class="px-2">
    <!-- add flight card -->
    <div
      v-if="
        isFirst && data?.length === 0 && ($canAccess(['agency', 'agency-employee', 'employee']) || $isTopBrandAdmin()) && !$is_PM && !$is_GD
      "
      class="text-center text-[#909399]"
    >
      <svg width="64" height="60" class="m-auto mb-3">
        <use :xlink:href="`#no-image`"></use>
      </svg>
      <p>Add individual flights to plan different phases of your campaign.</p>
      <ElButton type="primary" class="w-full" icon="el-icon-plus" @click="addFlight">New flight</ElButton>
    </div>
    <!-- end -->

    <template v-if="data?.length > 0">
      <div v-for="flight in data" :key="flight.id" class="bg-white w-full p-2 mb-1 rounded-md border border-grayNeutralLight relative">
        <RouterLink :to="{ name: 'flight-view', params: { id: campaign?.id, flight_id: flight.id } }" class="block text-center mb-1">
          <span
            class="w-[40px] h-[40px] rounded-full bg-[#F9F9FB] border border-grayNeutralLight flex items-center justify-center mx-auto mb-1"
          >
            <svg width="16" height="17">
              <use :xlink:href="`#calendar`"></use>
            </svg>
          </span>
          <el-tooltip v-if="flight?.name" popper-class="title-tooltip" effect="dark" :content="flight?.name" placement="bottom-start">
            <div class="font-bold text-dark text-base truncate">{{ flight?.name }}</div>
          </el-tooltip>
          <div class="font-bold text-dark text-base">{{ period(flight.start_date, flight.end_date) }}</div>

          <!-- Budget -->
          <CardLabel label="Budget" icon="money">
            <template v-if="flight.budget != null && flight.budget !== ''">&euro;{{ flight.budget }}</template>
            <template v-else>-</template>
          </CardLabel>
          <!-- end -->
          <!-- Impressions -->
          <CardLabel label="Impressions" icon="eyeImp">0/{{ flight.budget | impressions }}</CardLabel>
          <!-- end -->
          <!-- Assets -->
          <CardLabel v-if="flight.assets.length > 0" label="Asset sets" icon="doc">{{ flight.assets.length }}</CardLabel>
          <!-- end -->
        </RouterLink>
        <ActionMenu class="absolute top-2 right-2" :campaign="campaign" :flight="flight" />
        <!-- Cta Actions -->
        <template
          v-if="
            flight.assets.length > 0 &&
            [0].includes(flight.status) &&
            ($canAccess(['agency', 'agency-employee', 'employee']) || $isTopBrandAdmin()) &&
            !$is_PM &&
            !$is_GD
          "
        >
          <ElButton class="mt-0.5 w-full" type="primary" :disabled="flight.status === 2" @click="sendToReview(flight.id)">
            <i class="el-icon-position el-icon-left"></i> Send to review
          </ElButton>
        </template>

        <template
          v-if="
            flight.assets.length === 0 &&
            ($canAccess(['agency', 'agency-employee', 'employee']) || $isTopBrandAdmin()) &&
            !$is_PM &&
            !$is_GD
          "
        >
          <ElButton class="mt-0.5 w-full" type="primary" icon="el-icon-plus" plain @click="addAssets(flight.id)"> Add assets </ElButton>
        </template>
        <template v-if="$SBCampaignStatusAccess(['in_review'], flight.status) && flight.assets.length > 0 && $is_PM">
          <ElButton class="mt-0.5 w-full" type="primary" plain @click="goToFlight(flight)"> Review </ElButton>
        </template>
        <template
          v-if="
            $SBCampaignStatusAccess(['revision'], flight.status) &&
            ($canAccess(['agency', 'agency-employee', 'employee']) || $isTopBrandAdmin()) &&
            !$is_PM &&
            !$is_GD
          "
        >
          <ElButton class="mt-0.5 w-full" type="primary" plain @click="goToFlight(flight)"> View revision instructions </ElButton>
        </template>
        <!-- end -->
      </div>
    </template>
  </div>
</template>
<script>
import { evaluate } from 'mathjs'
import numbro from 'numbro'
import { FormatDate } from '@/utils'
import CardLabel from './CardLabel.vue'
import ActionMenu from './ActionMenu.vue'

import SendToReview from '@/components/social-products/social-boost/modal/SendToReview.vue'

export default {
  components: {
    CardLabel,
    ActionMenu,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
    isFirst: {
      type: Boolean,
      default: false,
    },
    campaign: {
      type: [Object, Boolean],
      required: true,
    },
  },
  filters: {
    impressions(budget) {
      const formula = '(budget / CPM) * 1000'
      if (budget) {
        const impresions = evaluate(formula, { budget: budget, CPM: 4 })
        return numbro(impresions).format({
          average: true,
          thousandSeparated: true,
        })
      } else {
        return '-'
      }
    },
  },
  computed: {},
  methods: {
    goToFlight(flight) {
      this.$router.push({ name: 'flight-view', params: { id: this.campaign?.id, flight_id: flight.id } })
    },
    addFlight() {
      this.$router.push({ name: 'social-boost-add-flight', params: { id: this.$route.params.id } })
    },
    addAssets(flight_id) {
      this.$router.push({ name: 'social-boost-add-assets', params: { id: this.$route.params.id, flight_id } })
    },
    period(start_date, end_date) {
      if (start_date && end_date) {
        return `${FormatDate(start_date, end_date)}`
      }
      return '-'
    },
    sendToReview(flight_id) {
      const flight = this.data.find((flight) => flight.id === flight_id)
      this.$Modal.init(
        {
          propsData: {
            component: SendToReview,
            meta: { campaign: this.campaign, id: this.campaign.id, flight_id, flight, isFlight: true },
            size: '480px',
          },
          callback(payload) {
            if (payload.event === 'modal:close') {
              console.log('>>>>>')
            }
          },
        },
        this
      )
    },
  },
}
</script>
